import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { db } from '../services/firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import '../styles/ShopsStyles.css';

const AboutPage = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [messageForm, setMessageForm] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 700);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handleMessageSubmit = async (e) => {
    e.preventDefault();
    
    // Trim whitespace and validate
    const trimmedName = messageForm.name.trim();
    const trimmedEmail = messageForm.email.trim();
    const trimmedMessage = messageForm.message.trim();
    
    if (!trimmedName || !trimmedEmail || !trimmedMessage) {
      setSubmitStatus('Please fill in all fields');
      setTimeout(() => setSubmitStatus(''), 3000);
      return;
    }

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(trimmedEmail)) {
      setSubmitStatus('Please enter a valid email address');
      setTimeout(() => setSubmitStatus(''), 3000);
      return;
    }

    setIsSubmitting(true);
    try {
      await addDoc(collection(db, 'contact_messages'), {
        name: trimmedName,
        email: trimmedEmail,
        message: trimmedMessage,
        timestamp: serverTimestamp(),
        read: false
      });
      
      setMessageForm({ name: '', email: '', message: '' });
      setSubmitStatus('Message sent successfully!');
      setTimeout(() => setSubmitStatus(''), 5000);
    } catch (error) {
      console.error('Error sending message:', error);
      setSubmitStatus('Error sending message. Please try again.');
      setTimeout(() => setSubmitStatus(''), 5000);
    }
    setIsSubmitting(false);
  };

  // Promo Banner (reuse)
  const PromoBanner = () => (
    <div style={{
      background: '#f8f8f8',
      borderBottom: '1px solid #e8e8e8',
      padding: '12px 24px',
      position: 'relative'
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '16px'
      }}>
        <div style={{
          width: '40px',
          height: '1px',
          background: '#ddd'
        }} />
        <span style={{
          fontSize: '13px',
          fontWeight: '500',
          color: '#333',
          textTransform: 'uppercase',
          letterSpacing: '1.5px',
          fontFamily: 'inherit'
        }}>
          Free Delivery on Orders Above QAR 100
        </span>
        <div style={{
          width: '40px',
          height: '1px',
          background: '#ddd'
        }} />
      </div>
    </div>
  );

  // Random promotional popup component
  const RandomPopup = () => {
    const [visible, setVisible] = useState(false);
    const [message, setMessage] = useState('');

    useEffect(() => {
      const promoMessages = [
        '🚚 Spend over QAR 100 and get FREE DELIVERY!',
        '🎉 Order QAR 100+ today — delivery is on us!',
        '⚡ Free delivery on every order above QAR 100!',
        '🤩 Limited time: QAR 100+ = FREE DELIVERY!'
      ];
      const delay = Math.random() * 8000 + 4000;
      const timer = setTimeout(() => {
        const randomMsg = promoMessages[Math.floor(Math.random() * promoMessages.length)];
        setMessage(randomMsg);
        setVisible(true);
      }, delay);
      return () => clearTimeout(timer);
    }, []);

    if (!visible) return null;
    return (
      <div className="random-popup" onClick={() => setVisible(false)}>
        <div className="random-popup-content">
          {message}
          <button className="random-popup-close">×</button>
        </div>
      </div>
    );
  };

  return (
    <div className="grey-bg-background">
      <style>{`
        @media (max-width: 700px) {
          /* CRITICAL: Override inline flex styles for cards section */
          section[style*="flexDirection: row"][style*="maxWidth: 1400"] {
            flex-direction: column !important;
            align-items: center !important;
            gap: 24px !important;
            padding: 0 20px !important;
            margin-bottom: 32px !important;
          }
          /* Override individual card flex properties */
          .aspiration-card[style*="flex: 1"],
          .commitment-card[style*="flex: 1"] {
            flex: none !important;
            width: 100% !important;
            max-width: 100% !important;
            min-width: 0 !important;
            margin: 0 !important;
            padding: 24px 16px !important;
          }
          /* Shrink the big GREY logo image */
          img[src*='biglogo'] {
            height: 60px !important;
            max-width: 90vw !important;
            margin-top: 8px !important;
            margin-bottom: 0 !important;
          }
          /* Shrink the hero image below the logo */
          img[src*='heropicabout'] {
            width: 100% !important;
            max-width: 100vw !important;
            max-height: 220px !important;
            object-fit: cover !important;
            margin-top: 12px !important;
            margin-left: 0 !important;
            border-radius: 0 !important;
          }
          /* Adjust spacing for hero section - reduce padding */
          section {
            padding: 0 16px 8px 16px !important;
          }
          /* Consistent spacing for text blocks */
          section > div, section > img {
            margin-left: auto !important;
            margin-right: auto !important;
          }
          /* Mobile text content - reduce margins */
          section div[style*='fontFamily: \'Inter'] {
            padding: 0 !important;
            margin: 0 auto 8px auto !important;
            font-size: 16px !important;
          }
          section div[style*='fontFamily: \'Georgia'] {
            padding: 0 !important;
            margin: 0 auto 12px auto !important;
            font-size: 16px !important;
          }
          /* Make sure the main-content-frame is not overflowing */
          .main-content-frame {
            padding-left: 0 !important;
            padding-right: 0 !important;
            overflow-x: hidden !important;
            width: 100% !important;
            max-width: 100vw !important;
          }
          /* Prevent all sections from overflowing */
          section {
            overflow-x: hidden !important;
            width: 100% !important;
            max-width: 100vw !important;
            box-sizing: border-box !important;
          }
          /* Ensure no elements extend beyond viewport */
          * {
            max-width: 100vw !important;
            box-sizing: border-box !important;
          }
          /* Fix specific image overflow */
          img[src*="heropicabout"] {
            width: 100% !important;
            margin-left: 0 !important;
            max-width: 100% !important;
          }
          /* Override the specific inline flex styles that are causing conflicts */
          section[style*="maxWidth: 1400"][style*="display: flex"][style*="flexDirection: row"] {
            display: flex !important;
            flex-direction: column !important;
            align-items: center !important;
            justify-content: center !important;
            gap: 24px !important;
            padding: 0 20px !important;
            width: 100% !important;
            max-width: 100vw !important;
            box-sizing: border-box !important;
          }
          /* Force individual card styling */
          div[class*="card"][style*="flex: 1"] {
            flex: none !important;
            width: 100% !important;
            max-width: 100% !important;
            margin: 0 !important;
            display: block !important;
          }
          .about-biglogo-desktop {
            display: none !important;
          }
          /* Force cards to stack vertically on mobile - reduce gaps and margins */
          section[style*='flex-direction: row'] {
            display: flex !important;
            flex-direction: column !important;
            align-items: center !important;
            gap: 16px !important;
            overflow: hidden !important;
            padding: 0 20px !important;
            margin-bottom: 16px !important;
            width: 100% !important;
            max-width: 100vw !important;
            box-sizing: border-box !important;
          }
          /* Target cards more specifically to override conflicts */
          section[style*='flex-direction: row'] > div.aspiration-card,
          section[style*='flex-direction: row'] > div.commitment-card,
          .aspiration-card,
          .commitment-card {
            width: calc(100% - 40px) !important;
            max-width: calc(100% - 40px) !important;
            min-width: 0 !important;
            margin: 0 !important;
            padding: 24px 16px !important;
            box-sizing: border-box !important;
            flex: none !important;
            flex-basis: auto !important;
            flex-grow: 0 !important;
            flex-shrink: 0 !important;
            overflow: hidden !important;
            display: block !important;
          }
          .aspiration-card .card-title,
          .commitment-card .card-title {
            font-size: 22px !important;
            margin-bottom: 12px !important;
            text-align: center !important;
          }
          .aspiration-card .card-text,
          .commitment-card .card-text {
            font-size: 15px !important;
            line-height: 1.5 !important;
            text-align: left !important;
          }
          /* Responsive video styles */
          section video, video {
            width: 100vw !important;
            min-width: 100vw !important;
            max-width: 100vw !important;
            height: 220px !important;
            min-height: 180px !important;
            max-height: 300px !important;
            object-fit: cover !important;
            display: block !important;
            margin: 0 auto !important;
            border-radius: 0 !important;
            background: #eaeaea !important;
          }
          .contact-card {
            width: 96% !important;
            padding: 32px 8px !important;
          }
          /* New contact section mobile styles */
          section div[style*='flex-direction: row'] {
            flex-direction: column !important;
            padding: 24px 0 !important;
          }
          section div[style*='width: 1'] {
            width: 80% !important;
            height: 1px !important;
            margin: 18px auto !important;
            background: #ececec !important;
          }
          /* Mobile video container - reduce margin */
          .about-video-container {
            padding: 0 20px !important;
            box-sizing: border-box !important;
            display: flex !important;
            justify-content: center !important;
            margin: 16px auto !important;
            width: 100% !important;
            max-width: 100vw !important;
            overflow: hidden !important;
          }
          .about-video-container video {
            width: 100% !important;
            min-width: 0 !important;
            max-width: 100% !important;
            height: 250px !important;
            border-radius: 0 !important;
            object-fit: cover !important;
            background: #eaeaea !important;
            box-shadow: 0 4px 16px rgba(0,0,0,0.12) !important;
            filter: contrast(1.05) brightness(0.95) !important;
            margin: 0 auto !important;
            display: block !important;
          }
          /* Ensure video section doesn't overflow - reduce bottom margin */
          section[style*='maxWidth: 1400'] {
            padding: 0 20px !important;
            margin-bottom: 16px !important;
            width: 100% !important;
            max-width: 100vw !important;
            box-sizing: border-box !important;
            overflow: hidden !important;
          }
        }
        .contact-link:hover {
          color: #0077b6 !important;
          text-decoration: underline !important;
        }
      `}</style>
      <div className="main-content-frame" style={{ 
        overflowX: 'hidden', 
        width: '100%', 
        maxWidth: '100vw' 
      }}>
        <div className="main-content-overlay"></div>
        <Header />
        <RandomPopup />
        {/* Hero Section */}
        <section
          style={{
            width: '100%',
            maxWidth: isMobile ? '100vw' : 1400,
            margin: '0 auto',
            padding: isMobile ? '0 20px 16px 20px' : '0 0 32px 0',
            textAlign: 'center',
            boxSizing: 'border-box',
          }}
        >
          <div
            style={{
              marginTop: 32,
              marginBottom: 0,
              width: '100%',
              maxWidth: 1100,
              marginLeft: 'auto',
              marginRight: 'auto',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <img
              src="/images/biglogo.png"
              alt="GREY"
              className="about-biglogo-desktop"
              style={{
                height: 160,
                width: 'auto',
                display: 'block',
                margin: '0 18px',
                objectFit: 'contain',
              }}
            />
          </div>
          <div style={{ 
            margin: '0 auto', 
            marginBottom: 18, 
            marginTop: 0, 
            maxWidth: isMobile ? '100%' : 600,
            overflow: 'hidden',
            width: '100%',
          }}>
            <img
              src="/images/heropicabout.png"
              alt="Grey Cafe"
              style={{
                width: isMobile ? '100%' : '127%',
                borderRadius: 0,
                objectFit: 'cover',
                marginTop: 20,
                marginLeft: isMobile ? 0 : -80,
                boxShadow: '0 2px 16px rgba(0,0,0,0.07)',
                maxWidth: isMobile ? '100%' : 'none',
              }}
            />
          </div>
          <div
            style={{
              fontFamily: 'Inter, Arial, sans-serif',
              fontSize: isMobile ? 16 : 18,
              color: '#222',
              margin: isMobile ? '0 auto 8px auto' : '0 auto 18px auto',
              maxWidth: isMobile ? '100%' : 800,
              textAlign: 'center',
              padding: '0',
              boxSizing: 'border-box',
            }}
          >
            From hand-picked, single-origin beans to eco-friendly practices that support farmers and
            the planet, every cup is crafted for quality and sustainability.
          </div>
          <div
            style={{
              width: isMobile ? '80%' : '90%',
              margin: isMobile ? '0 auto 8px auto' : '0 auto 18px auto',
              borderBottom: '1px solid #222',
              height: 0,
            }}
          />
          <div
            style={{
              fontFamily: 'Georgia, serif',
              fontSize: isMobile ? 16 : 18,
              color: '#222',
              margin: '0 auto',
              maxWidth: isMobile ? '100%' : 1100,
              lineHeight: 1.6,
              marginBottom: isMobile ? 12 : 24,
              textAlign: 'center',
              padding: '0',
              boxSizing: 'border-box',
            }}
          >
            Grey Specialty Coffee started from a deep passion for coffee, particularly roasting.
            Beginning with micro-roasting for our café and backed by collective funding from fellow
            enthusiasts, we entered the coffee industry with a commitment to specialty principles.
            Our coffee selections curated by Q Arabica Grader from our team. Our focus is to craft, research, and develop coffee as more than a product, building
            Qatar's specialty coffee community. Through carefully designed branding and educational
            marketing, we aim to reach more customers, raise awareness, and foster a sustainable
            ecosystem that supports the long-term growth of the specialty coffee industry.
          </div>
        </section>
        {/* Aspirations & Commitment Section */}
        <section
          style={{
            width: '100%',
            maxWidth: isMobile ? '100vw' : 1400,
            margin: '0 auto',
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            justifyContent: 'center',
            alignItems: isMobile ? 'center' : 'flex-start',
            gap: isMobile ? 24 : 32,
                          marginBottom: isMobile ? 16 : 64,
            padding: isMobile ? '0 20px' : '0',
            boxSizing: 'border-box',
          }}
        >
          <div
            className="aspiration-card"
            style={{
              flex: isMobile ? 'none' : 1,
              width: isMobile ? '100%' : 'auto',
              minWidth: isMobile ? 0 : 320,
              maxWidth: isMobile ? '100%' : 520,
              background: '#fff',
              border: '1px solid #ececec',
              borderRadius: 0,
              boxShadow: 'none',
              padding: isMobile ? '16px 12px' : '40px 32px',
              margin: isMobile ? '0' : '0 12px',
              textAlign: 'left',
              transition: 'all 0.3s ease',
              cursor: 'pointer',
              boxSizing: 'border-box',
            }}
          >
            <div
              className="card-title"
              style={{
                fontFamily: 'Inter, Arial, sans-serif',
                fontWeight: 700,
                fontSize: isMobile ? 22 : 28,
                letterSpacing: 1,
                marginBottom: isMobile ? 12 : 16,
                textAlign: 'center',
                color: '#222',
                transition: 'all 0.3s ease',
              }}
            >
              ASPIRATION
            </div>
            <div
              className="card-text"
              style={{
                fontFamily: 'Inter, Arial, sans-serif',
                fontSize: isMobile ? 15 : 17,
                color: '#666',
                lineHeight: isMobile ? 1.5 : 1.7,
                textAlign: 'left',
                transition: 'all 0.3s ease',
              }}
            >
              To establish Grey Specialty Coffee & Roastery as Qatar's foremost destination and
              trusted supplier for specialty coffee, distinguished by an unwavering commitment to
              quality, innovation, and cultural authenticity. Grey is dedicated to fostering a
              thriving community of coffee connoisseurs and supporting partner cafes in delivering
              an exceptional coffee experience with every cup.
            </div>
          </div>
          <div
            className="commitment-card"
            style={{
              flex: isMobile ? 'none' : 1,
              width: isMobile ? '100%' : 'auto',
              minWidth: isMobile ? 0 : 320,
              maxWidth: isMobile ? '100%' : 520,
              background: '#fff',
              border: '1px solid #ececec',
              borderRadius: 0,
              boxShadow: 'none',
              padding: isMobile ? '16px 12px' : '40px 32px',
              margin: isMobile ? '0' : '0 12px',
              textAlign: 'left',
              transition: 'all 0.3s ease',
              cursor: 'pointer',
              boxSizing: 'border-box',
            }}
          >
            <div
              className="card-title"
              style={{
                fontFamily: 'Inter, Arial, sans-serif',
                fontWeight: 700,
                fontSize: isMobile ? 22 : 28,
                letterSpacing: 1,
                marginBottom: isMobile ? 12 : 16,
                textAlign: 'center',
                color: '#222',
                transition: 'all 0.3s ease',
              }}
            >
              COMMITMENT
            </div>
            <div
              className="card-text"
              style={{
                fontFamily: 'Inter, Arial, sans-serif',
                fontSize: isMobile ? 15 : 17,
                color: '#666',
                lineHeight: isMobile ? 1.5 : 1.7,
                textAlign: 'left',
                transition: 'all 0.3s ease',
              }}
            >
              Our Mission Is To Elevate Coffee Experience in Qatar And GCC Providing Exceptional, Ethically Sourced The Rich, Diverse Culture Of Specialty Coffee. Grey Specialty Coffee & Roastery Is Dedicated To Empowering Our Partners Supporting Sustainable Practice And Engaging With The Coffee Community Through Education, Motivation, And Passion For The Craft.
            </div>
          </div>
        </section>
        {/* Video/Image Section */}
        <section
          style={{
            width: '100%',
            maxWidth: isMobile ? '100vw' : 1400,
            margin: isMobile ? '0 auto 16px auto' : '0 auto 64px auto',
            display: 'flex',
            justifyContent: 'center',
            padding: isMobile ? '0 20px' : '0 5%',
            boxSizing: 'border-box',
          }}
        >
          <div className="about-video-container" style={{ 
            width: '100%', 
            maxWidth: isMobile ? '100%' : 1100,
            display: 'flex',
            justifyContent: 'center',
            margin: '0 auto',
            boxSizing: 'border-box',
          }}>
          <video
            src="https://i.imgur.com/fJKIrUg.mp4"
            autoPlay
            loop
            muted
            playsInline
            style={{
              width: '100%',
              maxWidth: '100%',
              borderRadius: 0,
              objectFit: 'cover',
              height: isMobile ? 250 : 420,
              background: '#eaeaea',
              boxShadow: isMobile ? '0 4px 16px rgba(0,0,0,0.12)' : '0 8px 32px rgba(0,0,0,0.15)',
              filter: 'contrast(1.1) brightness(0.9)',
              transition: 'all 0.3s ease',
              display: 'block',
              margin: '0 auto',
              boxSizing: 'border-box',
            }}
            onError={(e) => {
              e.target.style.display = 'none';
              const fallback = document.createElement('div');
              fallback.style.cssText = `
                width: 100%;
                max-width: 1100px;
                height: 420px;
                background: linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 100%);
                display: flex;
                align-items: center;
                justify-content: center;
                font-family: Inter, Arial, sans-serif;
                color: #666;
                font-size: 18px;
                border-radius: 0;
                box-shadow: 0 8px 32px rgba(0,0,0,0.15);
              `;
              fallback.textContent = 'Video content temporarily unavailable';
              e.target.parentNode.appendChild(fallback);
            }}
          />
          </div>
          <style>{`
            .about-video-container video:hover {
              transform: scale(1.02) !important;
              filter: contrast(1.15) brightness(0.85) !important;
              box-shadow: 0 12px 40px rgba(0,0,0,0.25) !important;
            }
            .about-video-container:hover {
              transform: translateY(-3px) !important;
            }
          `}</style>
        </section>
        {/* Contact Us Section */}
        <section style={{
          width: '100%',
          maxWidth: isMobile ? '100vw' : 1200,
          margin: isMobile ? '0 auto 16px auto' : '0 auto 64px auto',
          padding: isMobile ? '0 12px' : '0 40px',
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: isMobile ? 'flex-start' : 'flex-start',
          gap: isMobile ? 24 : 48,
          boxSizing: 'border-box',
          overflowX: 'hidden'
        }}>
          {/* Contact Information */}
          <div className="contact-info-section" style={{
            flex: isMobile ? 'none' : '1',
            width: isMobile ? '100%' : 'auto',
            display: 'flex',
            flexDirection: 'column',
            gap: 24
          }}>
            <div style={{
              fontFamily: 'Inter, Arial, sans-serif',
              fontSize: 28,
              fontWeight: 700,
              color: '#222',
              marginBottom: 16,
              letterSpacing: '0.5px'
            }}>GET IN TOUCH</div>
            
            {/* Email Contact Card */}
            <div className="modern-contact-card" style={{
              background: '#fff',
              border: '1px solid #e8e8e8',
              padding: '24px',
              transition: 'all 0.3s ease',
              cursor: 'pointer'
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: 16
              }}>
                <div className="contact-icon-modern" style={{
                  width: 48,
                  height: 48,
                  background: '#f8f8f8',
                  border: '2px solid #222',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: 20,
                  color: '#222',
                  transition: 'all 0.3s ease'
                }}>@</div>
                <div>
                  <div style={{
                    fontFamily: 'Inter, Arial, sans-serif',
                    fontSize: 12,
                    fontWeight: 700,
                    color: '#666',
                    textTransform: 'uppercase',
                    letterSpacing: '1px',
                    marginBottom: 4
                  }}>Email Us</div>
                  <a href="mailto:sales@greydoha.qa"
                     className="modern-contact-link"
                     style={{
                       fontFamily: 'Inter, Arial, sans-serif',
                       fontSize: 16,
                       fontWeight: 600,
                       color: '#222',
                       textDecoration: 'none',
                       transition: 'all 0.3s ease'
                     }}
                  >
                    sales@greydoha.qa
                  </a>
                </div>
              </div>
            </div>

            {/* Phone Contact Card */}
            <div className="modern-contact-card" style={{
              background: '#fff',
              border: '1px solid #e8e8e8',
              padding: '24px',
              transition: 'all 0.3s ease',
              cursor: 'pointer'
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: 16
              }}>
                <div className="contact-icon-modern" style={{
                  width: 48,
                  height: 48,
                  background: '#f8f8f8',
                  border: '2px solid #222',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: 18,
                  color: '#222',
                  transition: 'all 0.3s ease'
                }}>☎</div>
                <div>
                  <div style={{
                    fontFamily: 'Inter, Arial, sans-serif',
                    fontSize: 12,
                    fontWeight: 700,
                    color: '#666',
                    textTransform: 'uppercase',
                    letterSpacing: '1px',
                    marginBottom: 4
                  }}>Call Us</div>
                  <a href="tel:+97459982808"
                     className="modern-contact-link"
                     style={{
                       fontFamily: 'Inter, Arial, sans-serif',
                       fontSize: 16,
                       fontWeight: 600,
                       color: '#222',
                       textDecoration: 'none',
                       transition: 'all 0.3s ease'
                     }}
                  >
                    +974 5998 2808
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Message Form Section - Redesigned */}
          <div className="message-form-section" style={{
            flex: isMobile ? 'none' : '1',
            width: isMobile ? 'calc(100% - 4px)' : 'auto',
            maxWidth: isMobile ? 'calc(100vw - 28px)' : 'none',
            background: '#fff',
            border: '1px solid #ececec',
            padding: isMobile ? '20px 16px' : '40px 32px',
            boxShadow: 'none',
            position: 'relative',
            boxSizing: 'border-box',
            overflowX: 'hidden'
          }}>
            {/* Header Section */}
            <div style={{
              textAlign: 'center',
              marginBottom: isMobile ? 24 : 32,
              paddingBottom: 16,
              borderBottom: '1px solid #222'
            }}>
              <div style={{
                fontFamily: 'Inter, Arial, sans-serif',
                fontSize: isMobile ? 22 : 28,
                fontWeight: 700,
                color: '#222',
                marginBottom: 8,
                letterSpacing: '1px',
                textTransform: 'uppercase'
              }}>SEND US A MESSAGE</div>
              <div style={{
                fontFamily: 'Georgia, serif',
                fontSize: isMobile ? 14 : 16,
                color: '#666',
                lineHeight: 1.6,
                fontStyle: 'italic'
              }}>Write it here and we'll get back to you soon</div>
            </div>
            
            <form onSubmit={handleMessageSubmit}>
              {/* Name Field */}
              <div style={{ marginBottom: isMobile ? 16 : 20 }}>
                <label style={{
                  display: 'block',
                  fontFamily: 'Inter, Arial, sans-serif',
                  fontSize: 12,
                  fontWeight: 700,
                  color: '#666',
                  textTransform: 'uppercase',
                  letterSpacing: '1px',
                  marginBottom: 8
                }}>Your Name</label>
                <input
                  type="text"
                  placeholder="Enter your full name"
                  value={messageForm.name}
                  onChange={(e) => setMessageForm({...messageForm, name: e.target.value})}
                  style={{
                    width: '100%',
                    padding: isMobile ? '12px 16px' : '16px 20px',
                    border: '1px solid #ececec',
                    borderRadius: 0,
                    fontSize: isMobile ? 14 : 16,
                    fontFamily: 'Inter, Arial, sans-serif',
                    outline: 'none',
                    transition: 'all 0.3s ease',
                    boxSizing: 'border-box',
                    background: '#fafafa'
                  }}
                  className="message-input"
                />
              </div>
              
              {/* Email Field */}
              <div style={{ marginBottom: isMobile ? 16 : 20 }}>
                <label style={{
                  display: 'block',
                  fontFamily: 'Inter, Arial, sans-serif',
                  fontSize: 12,
                  fontWeight: 700,
                  color: '#666',
                  textTransform: 'uppercase',
                  letterSpacing: '1px',
                  marginBottom: 8
                }}>Email Address</label>
                <input
                  type="email"
                  placeholder="your.email@example.com"
                  value={messageForm.email}
                  onChange={(e) => setMessageForm({...messageForm, email: e.target.value})}
                  style={{
                    width: '100%',
                    padding: isMobile ? '12px 16px' : '16px 20px',
                    border: '1px solid #ececec',
                    borderRadius: 0,
                    fontSize: isMobile ? 14 : 16,
                    fontFamily: 'Inter, Arial, sans-serif',
                    outline: 'none',
                    transition: 'all 0.3s ease',
                    boxSizing: 'border-box',
                    background: '#fafafa'
                  }}
                  className="message-input"
                />
              </div>
              
              {/* Message Field */}
              <div style={{ marginBottom: isMobile ? 20 : 24 }}>
                <label style={{
                  display: 'block',
                  fontFamily: 'Inter, Arial, sans-serif',
                  fontSize: 12,
                  fontWeight: 700,
                  color: '#666',
                  textTransform: 'uppercase',
                  letterSpacing: '1px',
                  marginBottom: 8
                }}>Your Message</label>
                <textarea
                  placeholder="Tell us about your inquiry, feedback, or how we can help you..."
                  value={messageForm.message}
                  onChange={(e) => setMessageForm({...messageForm, message: e.target.value})}
                  rows={isMobile ? 4 : 6}
                  style={{
                    width: '100%',
                    padding: isMobile ? '12px 16px' : '16px 20px',
                    border: '1px solid #ececec',
                    borderRadius: 0,
                    fontSize: isMobile ? 14 : 16,
                    fontFamily: 'Inter, Arial, sans-serif',
                    outline: 'none',
                    transition: 'all 0.3s ease',
                    resize: 'vertical',
                    minHeight: isMobile ? 100 : 140,
                    boxSizing: 'border-box',
                    background: '#fafafa',
                    lineHeight: 1.5
                  }}
                  className="message-input"
                />
              </div>
              
              {/* Submit Button */}
              <button
                type="submit"
                disabled={isSubmitting}
                style={{
                  width: '100%',
                  padding: isMobile ? '14px 16px' : '18px 24px',
                  background: isSubmitting ? '#ccc' : 'linear-gradient(135deg, #222 0%, #333 100%)',
                  color: '#fff',
                  border: 'none',
                  borderRadius: 0,
                  fontSize: isMobile ? 12 : 14,
                  fontWeight: 700,
                  fontFamily: 'Inter, Arial, sans-serif',
                  textTransform: 'uppercase',
                  letterSpacing: '1.5px',
                  cursor: isSubmitting ? 'not-allowed' : 'pointer',
                  transition: 'all 0.3s ease',
                  boxShadow: isSubmitting ? 'none' : '0 2px 8px rgba(0,0,0,0.1)',
                  position: 'relative',
                  overflow: 'hidden'
                }}
                className="message-submit-btn"
              >
                <span style={{
                  position: 'relative',
                  zIndex: 2
                }}>
                  {isSubmitting ? 'SENDING...' : 'SEND MESSAGE'}
                </span>
              </button>
              
              {/* Status Message */}
              {submitStatus && (
                <div style={{
                  marginTop: isMobile ? 12 : 16,
                  padding: isMobile ? '10px 12px' : '12px 16px',
                  background: submitStatus.includes('Error') ? '#f8f8f8' : '#f8f8f8',
                  color: submitStatus.includes('Error') ? '#d63031' : '#00b894',
                  fontSize: isMobile ? 12 : 14,
                  fontFamily: 'Inter, Arial, sans-serif',
                  textAlign: 'center',
                  border: `1px solid ${submitStatus.includes('Error') ? '#d63031' : '#00b894'}`,
                  borderRadius: 0,
                  fontWeight: 600,
                  letterSpacing: '0.5px'
                }}>
                  {submitStatus}
                </div>
              )}
            </form>
          </div>
          <style>{`
            .modern-contact-card:hover {
              transform: translateY(-2px);
              box-shadow: 0 8px 24px rgba(0,0,0,0.12);
              border-color: #222;
            }
            .modern-contact-card:hover .contact-icon-modern {
              background: #222;
              color: #fff;
              transform: scale(1.05);
            }
            .modern-contact-card:hover .modern-contact-link {
              color: #000;
            }
            .message-input:focus {
              border-color: #222 !important;
              background: #fff !important;
              box-shadow: 0 0 0 1px #222 !important;
              transform: translateY(-1px);
            }
            .message-input:hover:not(:focus) {
              border-color: #bbb !important;
              background: #fff !important;
            }
            .message-submit-btn:hover:not(:disabled) {
              background: linear-gradient(135deg, #000 0%, #222 100%) !important;
              transform: translateY(-2px);
              box-shadow: 0 6px 20px rgba(0,0,0,0.25) !important;
            }
            .message-submit-btn:active:not(:disabled) {
              transform: translateY(0);
              box-shadow: 0 2px 8px rgba(0,0,0,0.2) !important;
            }
            .message-submit-btn::before {
              content: '';
              position: absolute;
              top: 0;
              left: -100%;
              width: 100%;
              height: 100%;
              background: linear-gradient(90deg, transparent, rgba(255,255,255,0.1), transparent);
              transition: left 0.5s;
              z-index: 1;
            }
            .message-submit-btn:hover::before {
              left: 100%;
            }
            .aspiration-card:hover,
            .commitment-card:hover {
              transform: translateY(-3px) !important;
              box-shadow: 0 6px 24px rgba(0,0,0,0.12) !important;
              border-color: #222 !important;
              background: #222 !important;
            }
            .aspiration-card:hover .card-text,
            .commitment-card:hover .card-text {
              color: #fff !important;
            }
            .aspiration-card:hover .card-title,
            .commitment-card:hover .card-title {
              color: #fff !important;
            }
          `}</style>
        </section>
        <Footer />
      </div>
    </div>
  );
};

export default AboutPage;
